import { useEffect, useRef, useState } from "react";

export function useControlKey(key, cb) {
    const callback = useRef(cb);
    const [isKeyHeldDown, setIsKeyHeldDown] = useState(false);

    useEffect(() => {
        callback.current = cb;
    }, [cb]);

    useEffect(() => {
        function handleKeyDown(event) {
            if ((event.key === key && event.ctrlKey) && !isKeyHeldDown) {
                event.preventDefault();
                callback.current(event);
                setIsKeyHeldDown(true);
            }
        }

        function handleKeyUp(event) {
            if (event.key === key && event.ctrlKey) {
                setIsKeyHeldDown(false);
            }
        }

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, [key, isKeyHeldDown]);
}
